import React, { useEffect, useState } from 'react';
import AppContext from './data/AppContext';
import AppRouter from './AppRouter';
import { collection, onSnapshot, orderBy, query } from 'firebase/firestore';

//Styling
import '@shoelace-style/shoelace/dist/themes/light.css';
import { setBasePath } from '@shoelace-style/shoelace/dist/utilities/base-path';
import { ThemeProvider } from 'styled-components';
import baseTheme from './baseTheme';

import { Helmet } from 'react-helmet';


//translations
import i18next from 'i18next';
import {
  I18nextProvider,
  initReactI18next,
  useTranslation,
} from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { db } from './firebase/firebase-config';
import translations_de from './assets/locales/de/translation.json';
import translations_fr from './assets/locales/fr/translation.json';
import translations_en from './assets/locales/en/translation.json';

i18next
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    interpolation: { escapeValue: false }, // React already does escaping
    lng: 'de', // language to use
    fallbackLng: 'de',
    resources: {
      fr: {
        app: translations_fr,
      },
      de: {
        app: translations_de,
      },
      en: {
        app: translations_en,
      },
    },
  });

function App() {

  const { t } = useTranslation('app');

  setBasePath(
    'https://cdn.jsdelivr.net/npm/@shoelace-style/shoelace@2.3.0/dist/'
  );
  const [activeMountain, setActiveMountain] = useState(0);
  const [claimedMountainIds, setClaimedMountainIds] = useState([]);
  const [voices, setVoices] = useState([]);

  // set lang from get param
  const urlParams = new URLSearchParams(window.location.search);
  const lang = urlParams.get('lang');
  const { i18n } = useTranslation('app');
  useEffect(() => {
    if (lang === 'de' || lang === 'fr' || lang === 'en') {
      if (lang !== i18n.language) {
        i18n.changeLanguage(lang);
      }
    }
  }, [lang, i18n]);

  //get voices snapshot
  useEffect(() => {
    const mountainsCollectionRef = collection(db,
      (process.env.NODE_ENV === 'development' || window.location.hostname.includes('staging') || window.location.hostname.includes('glacier-challenge'))
        ? 'data-dev'
        : 'data'
    );

    console.log('Hostname:', window.location.hostname);
    console.log('Includes staging:', window.location.hostname.includes('staging'));

    const q = query(mountainsCollectionRef, orderBy('createdAt', 'desc'));
    const unsub = onSnapshot(q, (querySnapshot) => {
      const v = [];
      querySnapshot.forEach((doc) => {
        v.push(doc.data());
      });
      setVoices(v);
    });

    return () => {
      unsub();
    };
  }, []);

  // calc claimed mountains
  useEffect(() => {
    const ids = [];
    voices.forEach((voice) => {
      if (!ids.includes(voice.mountainId)) {
        ids.push(voice.mountainId);
      }
    });
    setClaimedMountainIds(ids);
  }, [voices]);

  return (
    <div>
      <Helmet>
        <title>{t('meta.title')}</title>
        <meta name="description" content={t('meta.description')} />
        <html lang={i18n.language} />

        {/* Open Graph */}
        <meta property="og:title" content={t('meta.title')} />
        <meta property="og:description" content={t('meta.description')} />
        <meta property="og:type" content="website" />
        <meta property="og:url" content={t('header.campaignLink')} />

        {/* Twitter */}
        <meta name="twitter:title" content={t('meta.title')} />
        <meta name="twitter:description" content={t('meta.description')} />
        {/* <meta name="twitter:card" content="summary_large_image" /> */}
      </Helmet>
      <I18nextProvider i18n={i18next}>
        <ThemeProvider theme={baseTheme}>
          <AppContext.Provider
            value={{
              activeMountain,
              claimedMountainIds,
              voices,
              setActiveMountain,
            }}
          >
            <AppRouter />
          </AppContext.Provider>
        </ThemeProvider>
      </I18nextProvider>
    </div>
  );
}
export default App;
